import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getProductAndSalesDocumentWithUniqueId } from '../../../Backend/firebase/product-and-sales';
import { dateFormatter } from '../../Models/CommonFunc';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function ViewProductAndSales({ productAndSalesId }) {
    const classes = useStyles();
    const [records, setRecords] = useState([]);

    useEffect(async () => {
        try {
            const getProductAndSales = await getProductAndSalesDocumentWithUniqueId(productAndSalesId);
            setRecords(getProductAndSales[0]);
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update Product And Sales." />
                    <title>View Product And Sales | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <div className="card-events-popup">
                        <div className="card-events-body d-flex flex-column">
                            <div className="card-events-details-popup">
                                <h5 className="card-events-title product__mainTitle">{records.ProductName}</h5>
                                <p className="card-events-title">{records.ProductType}</p>
                                <p className="card-events-title">HSN Code: <b>{records.HSNCode ? `${records.HSNCode}` : 'NA'}</b></p>
                                {records.GSTClass && <p className="card-events-title">GST Class: <b>{records.GSTClass ? `${records.GSTClass}%` : '0'}</b></p>}
                                {records.PrimaryPack && <p className="card-events-title">Primary Pack: <b>{records.PrimaryPack}</b></p>}
                                {records.SecondaryPack && <p className="card-events-title">Secondary Pack: <b>{records.SecondaryPack}</b></p>}
                                {records.PackConversion && <p className="card-events-title">Pack Conversion: <b>{records.PackConversion}</b></p>}
                                {records.StockAsPerPrimaryPack && <p className="card-events-title">Stock (As per Primary Pack): <b>{records.StockAsPerPrimaryPack}</b></p>}
                                {records.MRPAsPerPrimaryPack && <p className="card-events-title">MRP (as per Primary Pack): <b>{`Rs.${records.MRPAsPerPrimaryPack}`}</b></p>}
                                {records.SellingPriceAsPerPrimaryPack && <p className="card-events-title">Selling Price (as per primary pack): <b>{`Rs.${records.SellingPriceAsPerPrimaryPack}`}</b></p>}
                                {records.SchemeQuantity && <p className="card-events-title">Scheme Quantity: <b>{records.SchemeQuantity}</b></p>}
                                {records.Pack && <p className="card-events-title">Pack: <b>{records.Pack}</b></p>}
                                {records.SchemeReward && <p className="card-events-title">Scheme Reward: <b>{records.SchemeReward}</b></p>}
                                {records.ExpiryDate && <p className="card-events-title">Expiry Date: <b>{typeof records.ExpiryDate == "string" ? records.ExpiryDate : dateFormatter(records.ExpiryDate.toDate().toString())}</b></p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewProductAndSales
